import { authGuard } from '@auth0/auth0-vue';

import DashboardContainer from '@/components/DashboardContainer.vue';
import OnboardingLayout from '@/components/OnboardingLayout.vue';
import Auth0Callback from '@/components/Auth0Callback.vue';
import EulaPage from '@/components/EulaPage.vue';

import HomeView from '@/views/HomeView.vue';
import GetStarted from '@/views/GetStarted.vue';
import KeysVault from '@/views/KeysVault.vue';
import AccountView from '@/views/AccountView.vue';
import SDKDownload from '@/views/SDKDownload.vue';
import UsageView from '@/views/UsageView.vue';
import TermsView from '@/views/TermsView.vue';
import ErrorView from '@/views/ErrorView.vue';
import DemoView from '@/views/DemoView.vue';
import NotFound from '@/views/NotFound.vue';
import QuoteConversionView from '@/views/QuoteConversionView.vue';
import AdminQuotesView from '@/views/AdminQuotesView.vue';

import AllUsers from '@/views/admin/AllUsers.vue';
import IndividualUser from '@/views/admin/IndividualUser.vue';
import EcosystemReport from '@/views/admin/EcosystemReport.vue';
import UserReport from '@/views/admin/UserReport.vue';
import ReportingContainer from '@/views/admin/ReportingContainer.vue';
import AdminView from '@/views/admin/AdminView.vue';
import UploadSdk from '@/views/admin/UploadSdk.vue';
import QuoteGenerationView from '@/views/admin/QuoteGenerationView.vue';
import TransferSdkKey from '@/views/admin/TransferSdkKey.vue';
import SpecialFiles from '@/views/admin/SpecialFiles.vue';

import SubscriptionTierSelection from '@/views/SubscriptionTierSelection.vue';
import BillingInfo from '@/views/BillingInfo.vue';
import CheckoutReturn from '@/views/CheckoutReturn.vue';
import CheckoutView from '@/views/CheckoutView.vue';

export const routes = [
  { path: '/login', redirect: '/' },
  { path: '', name: 'HomeView', component: HomeView, meta: { public: true } },
  { path: '/resources/call', name: 'DemoView', component: DemoView, meta: { public: true } },
  { path: '/auth0callback', name: 'auth0callback', component: Auth0Callback, meta: { public: true } },
  { path: '/eula', name: 'Eula', component: EulaPage, meta: { public: true } },

  {
    path: '/console',
    name: 'Dashboard',
    component: DashboardContainer,
    beforeEnter: authGuard,
    meta: { requiresAuth: true },
    children: [
      { path: 'getstarted', name: 'GetStarted', component: GetStarted },
      { path: 'account', name: 'AccountView', component: AccountView },
      { path: 'checkout/return', name: 'CheckoutReturn', component: CheckoutReturn },
      { path: 'vault/api-keys', redirect: '/console/vault/sdk-keys' },
      {
        path: 'vault/sdk-keys',
        name: 'KeysVault',
        component: KeysVault,
        meta: { roles: ['sdk_access'] },
      },
      {
        path: 'downloads/:package',
        name: 'SDKDownload',
        component: SDKDownload,
        meta: { permissions: ['sdk_access'] },
      },
      {
        path: 'usage',
        name: 'Usage',
        component: UsageView,
        meta: { permissions: ['sdk_access'] },
      },
      {
        path: 'enterprise/subscription',
        name: 'QuoteConversionView',
        component: QuoteConversionView,
      },

      // ── Admin ──────────────────────────────────────────
      {
        path: 'admin',
        name: 'Admin',
        component: AdminView,
        redirect: '/console/admin/users',
        meta: { permissions: ['admin_only'] },
        children: [
          {
            path: 'users',
            name: 'AllUsers',
            component: AllUsers,
            children: [
              { path: ':id', name: 'IndividualUser', component: IndividualUser },
            ],
          },
          { path: 'sdk-release', name: 'UploadSdk', component: UploadSdk },
          { path: 'special-files', name: 'AdminSpecialFiles', component: SpecialFiles, meta: { permissions: ['admin_only'] } },
          { path: 'quotes', name: 'AdminQuotesView', component: AdminQuotesView },
          { path: 'key-transfer', name: 'KeyTransfer', component: TransferSdkKey, meta: { permissions: ['admin_only'] } },
          {
            path: 'quote-generation/:id',
            name: 'QuoteGenerationView',
            component: QuoteGenerationView,
          },
          {
            path: 'reporting',
            name: 'Reporting',
            component: ReportingContainer,
            redirect: '/console/admin/reporting/ecosystem',
            children: [
              { path: 'ecosystem', name: 'EcosystemReport', component: EcosystemReport },
              { path: 'users', name: 'UserReport', component: UserReport },
            ],
          },
        ],
      },

      // ── Onboarding ─────────────────────────────────────
      {
        path: 'onboarding',
        component: OnboardingLayout,
        children: [
          { path: 'terms', name: 'TermsView', component: TermsView, meta: { step: 1, totalSteps: 4 } },
          { path: 'subscription', name: 'SubscriptionTierSelection', component: SubscriptionTierSelection, meta: { step: 2, totalSteps: 4 } },
          { path: 'billing', name: 'BillingInfo', component: BillingInfo, meta: { step: 3, totalSteps: 4 } },
          { path: 'checkout', name: 'CheckoutView', component: CheckoutView, meta: { step: 4, totalSteps: 4 } },
        ],
      },
    ],
  },

  { path: '/error', name: 'ErrorView', component: ErrorView, meta: { public: true } },
  { path: '/:pathMatch(.*)*', name: 'NotFound', component: NotFound, meta: { public: true } },
];